// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ms-0";